const GlowBadge = ({ text }: { text: string }) => {
  return (
    <span
      className="flex h-5 items-center justify-center rounded border border-th-active px-1 text-xxs leading-relaxed text-th-active"
      style={{
        boxShadow:
          '0 0 1px var(--active), 0 0 0.5em var(--active), 0 0 0.25em var(--active), 0 0 0.1em var(--active)',
        textShadow:
          '0 0 1px, 0 0 0.5em var(--active), 0 0 0.25em var(--active), 0 0 0.1em var(--active)',
      }}
    >
      {text}
    </span>
  )
}

export default GlowBadge
